import { render, staticRenderFns } from "./RequestDetailModal.vue?vue&type=template&id=3814041c&scoped=true&"
import script from "./RequestDetailModal.vue?vue&type=script&lang=ts&"
export * from "./RequestDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestDetailModal.vue?vue&type=style&index=0&id=3814041c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814041c",
  null
  
)

export default component.exports